import AssignmentDetailSheet from "./AssignmentDetailSheet"

type Props = {
  guidelines: string
  richTextClassName: string
  open: boolean
  onClose: () => void
}

const SubmissionGuidelines = ({
  guidelines,
  richTextClassName,
  open,
  onClose,
}: Props) => (
  <AssignmentDetailSheet
    title="Submission Guidelines"
    open={open}
    onClose={onClose}
  >
    <div
      className={richTextClassName}
      dangerouslySetInnerHTML={{
        __html: guidelines,
      }}
    />
  </AssignmentDetailSheet>
)

export default SubmissionGuidelines
